import { formatPrice, getProductPriceWithDiscountText } from '@/utils/number';
import React from 'react';
import { cn } from '@/utils/cn';
import { LIST_VIEW } from '@/constants';
import Badge from '../../Badge';
import TextBase from '../../Typography/TextBase';
import TextSmall from '../../Typography/TextSmall';

function ProductCardPrice({ productData, viewType = LIST_VIEW }) {
  const { price, text } = getProductPriceWithDiscountText(productData?.price);

  return (
    <div
      className={cn(
        'block min-h-[36px] lg:min-h-[44px] sm:flex flex-col items-start mb-[4px] lg:mb-[8px]',
        {
          'sm:items-start lg:mb-8': viewType === LIST_VIEW,
        },
      )}
    >
      <div className="flex items-center gap-x-1">
        <TextBase
          text={`৳ ${formatPrice(parseFloat(productData?.price?.final_price))}`}
          className="text-richcarmine font-bold lg:font-semibold whitespace-nowrap"
        />

        {price > 0 ? (
          <Badge
            type="discount-offer-badge"
            offerText={text}
            className="h-[20px] lg:h-[24px]"
          />
        ) : null}
      </div>
      {price > 0 ? (
        <TextSmall
          text={`৳ ${formatPrice(parseFloat(price))}`}
          className="text-lightslategray font-medium whitespace-nowrap line-through"
        />
      ) : null}
    </div>
  );
}

export default ProductCardPrice;
